import type { FC } from 'react';

import { _isNotEmpty } from '@/littledash';
import { type MetadataFieldWithValue } from '@/model/Metadata.model';

import Metadata from '../Metadata';
import { type MetadataSection } from '../useMetadataSections';

interface MetadataPanelProps {
  sections: Array<MetadataSection>;
  fallback: Array<MetadataFieldWithValue>;
}

const MetadataPanel: FC<MetadataPanelProps> = ({ sections, fallback }) => {
  if (_isNotEmpty(sections)) {
    return (
      <>
        {sections.map((section, index) => (
          <div key={section.name} className={`ui-card ${index > 0 ? 'mt4' : ''}`}>
            <h3 className="f4 lh-title pa3">{section.name}</h3>
            <div className="bt b--moon-gray">
              <Metadata metadata={section.metadata} />
            </div>
          </div>
        ))}
      </>
    );
  }

  return (
    <div className="ui-card mt4">
      <div className="bt b--moon-gray">
        <Metadata metadata={fallback} />
      </div>
    </div>
  );
};

export default MetadataPanel;
